// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2350":"c9026179","5209":"aba3188c","6444":"2723e70b"}[chunkId] + ".chunk.css";
};